import { stringToColor } from 'shared/utils/stringToColor'

// EventOut.status is a free string; these three match shared/utils/activityStatuses' keys.
// Colour pairs follow the Issue status palette (service SelectIssueModal's
// getStyleProgressStatus): open-ish blue, done green, cancelled red.
export const EVENT_STATUSES = [
  { code: 'scheduled', name: 'Scheduled', bg: '#deebff', fg: '#0747a6' },
  { code: 'completed', name: 'Completed', bg: '#e3fcef', fg: '#006644' },
  { code: 'canceled', name: 'Canceled', bg: '#fdeaea', fg: '#8a1c1c' },
]

export const EVENT_STATUS_OPTIONS = EVENT_STATUSES.map(s => ({ value: s.code, text: s.name }))

const fallback = { name: '', bg: '#e0e0e0', fg: '#42526e' }

export const eventStatusMeta = (code) => EVENT_STATUSES.find(s => s.code === code) || { ...fallback, name: code || '' }

// Neutral fallback — events with no linked Calendar record (the common case: a plain
// local event never gets a per-owner color, only ones actually attached to a Calendar do,
// whether externally synced or manually picked in EventForm.js's own Calendar select).
const NO_CALENDAR_COLOR = '#9e9e9e'

// The event/agenda-row color bar/dot — hashed from the linked Calendar's owner name via
// shared/utils/stringToColor (same function shared/ui/AvatarInitial.js uses for avatar
// circles, so a person's event color and their own avatar render the exact same hex).
// Replaces the old status-driven eventStatusColor at these same two call sites
// (EventRow.js/AgendaEventItem.js) — status is still shown via eventStatusMeta's chip
// elsewhere (EventDetailSidebar.js/DailyEventSidebar.js), untouched.
export const eventOwnerColor = (event) => {
  const owner = event?.calendar?.owner
  const fullName = owner ? `${owner.first_name || ''}${owner.last_name || ''}`.trim() || owner.email : null
  return fullName ? stringToColor(fullName) : NO_CALENDAR_COLOR
}

export const eventStatusChipStyle = (code) => {
  const { bg, fg } = eventStatusMeta(code)
  return {
    padding: '0 10px',
    borderRadius: '4px',
    fontWeight: 500,
    backgroundColor: bg,
    color: fg,
  }
}
